<template>
  <div class="background-pub-pop">
    <PublicForm :width="'100px'" :formData="formData" :formList="cols" />
  </div>
</template>

<script>
import { getCommonAjax } from "@/api/common";
export default {
  props: ["subData"],
  data() {
    return {
      formData: {},
      cols: [
        {
          label: "设备名称",
          cusprop: "device.car.name",
          component: "popContent",
        },
        {
          label: "设备编号",
          cusprop: "device.car.number",
          component: "popContent",
        },
        {
          label: "北斗卡号",
          cusprop: "device.cardNumber",
          component: "popContent",
        },
        {
          label: "经度",
          cusprop: "deviceLocation.longitude",
          component: "popContent",
        },
        {
          label: "纬度",
          cusprop: "deviceLocation.latitude",
          component: "popContent",
        },
        {
          label: "高程(米)",
          cusprop: "deviceLocation.altitude",
          component: "popContent",
        },
        {
          label: "速度(km/h)",
          cusprop: "deviceLocation.speed",
          component: "popContent",
        },
        {
          label: "定位时间",
          cusprop: "deviceLocation.createTime",
          component: "popContent",
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    update(x, y, z) {
      if (!this.formData || !this.formData.deviceLocation) {
        return;
      }

      let lon_arr = this.formatDegree(x);
      let lat_arr = this.formatDegree(y);

      this.formData.deviceLocation.longitude = `${lon_arr[0]}°${lon_arr[1]}′${lon_arr[2]}″`;
      this.formData.deviceLocation.latitude = `${lat_arr[0]}°${lat_arr[1]}′${lat_arr[2]}″`;
      this.formData.deviceLocation.altitude = Number(z).toFixed(2);
      this.formData.deviceLocation.speed = 300;
    },
    getData() {
      getCommonAjax("/device/getDeviceDetail", {
        cardNumber: this.subData,
      })
        .then((res) => {
          this.formData = res.result;

          if (!this.formData || !this.formData.deviceLocation) {
            return;
          }

          let lon_arr = this.formatDegree(this.formData.deviceLocation.longitude);
          let lat_arr = this.formatDegree(this.formData.deviceLocation.latitude);

          this.formData.deviceLocation.longitude = `${lon_arr[0]}°${lon_arr[1]}′${lon_arr[2]}″`;
          this.formData.deviceLocation.latitude = `${lat_arr[0]}°${lat_arr[1]}′${lat_arr[2]}″`;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    formatDegree(value) {
      value = Math.abs(value);
      var v1 = Math.floor(value); //度
      var v2 = Math.floor((value - v1) * 60); //分
      var v3 = Math.round(((value - v1) * 3600) % 60); //秒
      return [v1, v2, v3];
    },
  },
};
</script>

<style>
.background-pub-pop {
}
</style>
